export function getDeviceIdForAppiumScripts(selectedDevice) {
  let deviceId;

  if (selectedDevice?.type === 'android') {
    // prefer device_id_3 over device_id_1 for Android,
    // because on device_id_3 we will save the serial number of physical device
    // for emulators, there will not be any serial number, so we will use device_id_1,
    // and in scenarios_disptatcher this id will be resolved with the adb runner
    deviceId = selectedDevice?.device_id_3 || selectedDevice?.device_id_1;
  } else {
    deviceId = selectedDevice?.device_id_3;
  }
  return deviceId;
}
